var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"color":"black","top":"","disabled":_vm.disableTooltip},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('keep-alive',[_c(_vm.computedTag,_vm._g({tag:"component",class:[..._vm.classProp],style:([
          _vm.additionalStyling ? _vm.additionalStyling : '',
          _vm.applyClamp ? _vm.clampText : ''
        ]),attrs:{"id":_vm.id && _vm.id !== '' ? _vm.id : ''},domProps:{"innerHTML":_vm._s(_vm.text)}},on))],1)]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }